import { render } from "./MarketWidget.vue?vue&type=template&id=0cd47f4e&scoped=true"
import script from "./MarketWidget.vue?vue&type=script&lang=js"
export * from "./MarketWidget.vue?vue&type=script&lang=js"

import "./MarketWidget.vue?vue&type=style&index=0&id=0cd47f4e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd47f4e"]])

export default __exports__